import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UtilService } from 'src/app/shared/services';

@Component({
  selector: 'app-press-club-item',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './press-club-item.component.html',
  styleUrls: ['./press-club-item.component.scss']
})
export class PressClubItemComponent {
  @Input() pressClubItem;
  constructor(
    public util: UtilService
  ) {}
  colors = [
    '#007ec4',
    '#002955',
    '#c34cd2',
    '#ec4976',
    '#00ced1',
    '#786551',
    '#828af1',
    '#63241f',
    '#786551',
    '#ff033e',
    '#93ff00'
  ]

  redirectToUrl(){
    this.util.nativeNavigation(this.pressClubItem.source_link, true);
  }
}
